var _g, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendedBranchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 17,
    height: 17,
    viewBox: "5 3 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_187_144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9.5,
    r: 6.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4997,
    cy: 9.4999,
    r: 4.41071,
    stroke: "#FFB71B",
    strokeWidth: 1.39286
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5001,
    cy: 9.50001,
    r: 2.08929,
    stroke: "#FFB71B",
    strokeWidth: 1.39286
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_187_144",
    x: 0.821429,
    y: 0.678572,
    width: 21.3571,
    height: 21.3571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.85714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08929
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_187_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_187_144",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedBranchIcon);
export default __webpack_public_path__ + "static/media/recommended-branch-icon.8b26b5df46d1606f2b011418dfaef790.svg";
export { ForwardRef as ReactComponent };